import React from 'react'
import Description from 'components/Slides/Description'

export default Description({
  description: () => (
    <div>
      <p>Let’s have a look at loops and how they work in WordPress…</p>
    </div>
  ),
})



// WEBPACK FOOTER //
// ./src/slides/wordpress/cool-mat-week-2/slides/04-what-are-loops.js